<!-- 批量添加仓位 -->
<template>
    <div class="business-content-main space-edit">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">仓库</div>
                <el-input class="search-item" size="small" disabled v-model="submitData.warehouseName"></el-input>
                <el-button
                    size="small"
                    class="search-btn btn-primary"
                    style="margin-left: 10px"
                    :disabled="!canSave"
                    @click="
                        () => {
                            dialogVisible = true;
                        }
                    "
                    >批量生成</el-button
                >
                <el-button size="small" class="search-btn btn-primary" :disabled="!canSave" @click="submit()">提交</el-button>
            </div>
        </div>
        <div id="infinite-list">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                height="700px"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle"
                highlight-current-row
                row-id="rowkey"
            >
                <ux-table-column field="Code" title="编码" resizable :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot:edit="scope">
                        <el-input v-model="scope.row.Code" size="small"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Name" title="名称" resizable :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot:edit="scope">
                        <el-input v-model="scope.row.Name" size="small"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="UseDesc" title="用途" resizable :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot:edit="scope">
                        <el-input v-model="scope.row.UseDesc" size="small"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Remark" title="备注" resizable :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot:edit="scope">
                        <el-input v-model="scope.row.Remark" size="small"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="SpaceType" title="仓位类型" edit-render>
                    <template v-slot="{ row }"
                        ><span>{{ row.SpaceType | spaceTypeHandle }}</span></template
                    >
                    <template v-slot:edit="scope">
                        <el-select v-model="scope.row.SpaceType" class="search-item" size="small" placeholder="请选择">
                            <el-option v-for="item in spaceTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="ZoneId" title="设置区域" edit-render>
                    <template v-slot="{ row }"
                        ><span>{{ row.ZoneId | ZoneHandle(zoneList) }}</span></template
                    >
                    <template v-slot:edit="scope">
                        <el-select v-model="scope.row.ZoneId" class="search-item" size="small" placeholder="请选择">
                            <el-option v-for="item in zoneList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="edit" title="操作" width="120">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <el-button size="small" @click="delItem(rowIndex)" icon="el-icon-delete" :tabindex="-1" v-if="dataList.length !== 1"></el-button>
                            <el-button size="small" type="primary" @click="addItem()" icon="el-icon-plus" v-if="rowIndex + 1 === dataList.length"></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <el-dialog :close-on-click-modal="false" title="设置编号规则" :visible.sync="dialogVisible" width="800px">
            <div class="dialog-content" v-if="dialogVisible" v-loading="loading">
                <div class="form-main">
                    <el-form ref="codeRuleForm" :model="codeRuleData" :rules="formRules" label-width="100px">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="货架号前缀" prop="SNo">
                                        <el-input v-model.trim="codeRuleData.SNo" placeholder="请输入货架号前缀，如F,1F"></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="货架排数" prop="SCount">
                                        <el-input v-model.trim="codeRuleData.SCount" placeholder="请输入货架排数或区间"></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="货架层数" prop="FloorCount">
                                        <el-input v-model.trim="codeRuleData.FloorCount" placeholder="请输入货架层数或区间"></el-input>
                                        <!-- <el-input-number v-model="codeRuleData.FloorCount" controls-position="right" :min="1" :max="10"  style="width: 100%;"></el-input-number> -->
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="每层货位数" prop="FSpaceCount">
                                        <el-input v-model.trim="codeRuleData.FSpaceCount" placeholder="请输入每层货位数或区间"></el-input>
                                        <!-- <el-input-number v-model="codeRuleData.FSpaceCount" controls-position="right" :min="1"   style="width: 100%;"></el-input-number> -->
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="后缀">
                                        <el-input v-model.trim="codeRuleData.Suffix" placeholder="请输入货位后缀,如C,2C"></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="仓位类型">
                                        <el-select v-model="codeRuleData.SpaceType" style="width: 100%;" placeholder="请选择">
                                            <el-option v-for="item in spaceTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="设置区域">
                                        <el-select v-model="codeRuleData.ZoneId" style="width: 100%;" placeholder="请选择">
                                            <el-option v-for="item in zoneList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col>
                                <label style="color: red">*生成编码规则：前缀+排-层-货位，如：1F1-1-1C(1F货架的第一排第一层的第一个货位,C为货位后缀)，若编码存在则会跳过</label><br />
                                <!-- <label style="color:red;">*货架号前缀，只能是英文，或数字开头加英文</label><br/> -->
                                <label style="color: red">*货架号前缀，只能是英文或数字</label><br />
                                <label style="color: red">*货架排数：当输入值为整数时，表示生成多少排货架编号；如果是使用分隔符',',则或生成这个区间的编号</label><br />
                                <label style="color: red">*货架层数：当输入值为整数时，表示生成多少层货架；如果是使用分隔符',',则生成对应的层数</label><br />
                                <label style="color: red">*每层货位数：当输入值为整数时，表示生成多少个货位；如果是使用分隔符',',则生成这个区间的货位</label>
                                <label style="color: red">*货位后缀：输入后缀,货位最后面会固定生成对应的后缀,且后缀不会递增,后缀为非必填项</label>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" @click="generateNo">生成</el-button>
                        <el-button
                            @click="
                                () => {
                                    dialogVisible = false;
                                }
                            "
                            >取消</el-button
                        >
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
export default {
    components: { breadcrumb },
    data() {
        const codeRules = ({ cellValue, rule }) => {
            if (!cellValue) {
                return new Error('编码必填');
            } else {
                let rowArr = this.dataList.filter(f => f.Code === cellValue);
                if (rowArr.length > 1) return new Error('不可输入重复编码');
            }
        };
        return {
            spaceTypeList: [
                { Value: '0', Text: '标准仓' },
                { Value: '1', Text: '临时仓' },
                { Value: '2', Text: '废品仓' }
            ],
            rules: {
                Code: [{ required: true, validator: codeRules }],
                Name: [{ required: true, message: '名称必填' }]
            },
            dataList: [],
            submitData: {
                warehouseName: '',
                WarehouseId: '',
                ShelfSpacesList: []
            },
            dialogVisible: false,
            codeRuleData: {
                SNo: '',
                SCount: 1,
                SpaceStart: 1,
                SpaceEnd: 1,
                FloorCount: 1,
                FSpaceCount: 1,
                Suffix:'',
                SpaceType:'0',
                ZoneId:''
            },
            loading: false,
            formRules: {
            //     SNo: [
            //         { required: true, message: '该项必填', trigger: 'blur' },
            //         {
            //             validator: function (rule, value, callback) {
            //                 //^[A-Za-z0-9]+$ 由数字和26个英文字母组成的字符串
            //                 //^([0-9])?[A-Za-z]+$只能是英文，或数字开头加英文
            //                 //  校验英文的正则
            //                 // if (/^([0-9])?[A-Za-z]+$/.test(value) == false) {
            //                 //     callback(new Error("请输入英文字母"));
            //                 // }
            //                 if (/^[A-Za-z0-9]+$/.test(value) == false) {
            //                     callback(new Error('只能是英文或数字'));
            //                 } else {
            //                     //校验通过
            //                     callback();
            //                 }
            //             },
            //             trigger: 'blur'
            //         }
            //     ],
                SNo: [{ required: true, message: '该项必填', trigger: 'blur' }],
                SCount: [{ required: true, message: '该项必填', trigger: 'blur' }],
                FloorCount: [{ required: true, message: '该项必填', trigger: 'blur' }],
                FSpaceCount: [{ required: true, message: '该项必填', trigger: 'blur' }]
            },
            canSave: true,
            zoneList:[]
        };
    },
    mounted() {
        this.submitData.WarehouseId = this.$route.query.id;
        this.submitData.warehouseName = this.$route.query.name;
        this.addItem();
        this.getZoneList();
    },
    filters: {
        spaceTypeHandle(value) {
            switch (value) {
                case '0':
                    return '标准仓';
                case '1':
                    return '临时仓';
                case '2':
                    return '废品仓';
                default:
                    return '未知';
            }
        },
        ZoneHandle(value,list) {
            if(value){
                let zone = list.find(x=>x.Id == value);
                if(zone)
                    return zone.Name
            }
        }
    },
    methods: {
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
        },
        addItem() {
            let that = this;
            for (let i = 0; i < that.dataList.length; i++) {
                if (!that.dataList[i].Code) {
                    that.$util.warningMsg('仓位编号不能为空');
                    return;
                }
            }
            that.dataList.push({
                Code: '',
                Name: '',
                UseDesc: '',
                Remark: '',
                SpaceType: '0'
            });
        },
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = this.dataList.filter(f => f.Code === row.Code);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        submit() {
            let that = this;

            if (!that.dataList || that.dataList.length == 0) {
                that.$util.warningMsg('请添加仓位');
                return;
            }
            for (let i = 0; i < that.dataList.length; i++) {
                if (!that.dataList[i].Code) {
                    that.$util.warningMsg('仓位编号不能为空');
                    return;
                }
                let sameItems = that.dataList.filter(item => item.Code == that.dataList[i].Code);
                if (sameItems.length > 1) {
                    that.$util.warningMsg(`存在相同的仓位编号【${that.dataList[i].Code}】`);
                    return;
                }
            }
            that.submitData.ShelfSpacesList = that.dataList;
            that.$util
                .axiosPost({
                    url: '/api/EntpShelfSpaces/BatchSave',
                    data: that.submitData
                })
                .then((res) => {
                    that.$util.successMsg(res.errmsg);
                    that.$store.commit('updateNeedRefresh', true);
                    setTimeout(() => {
                        that.$router.push(`/inventoryManage/warePosition?id=${that.submitData.WarehouseId}&warehouse=${that.submitData.warehouseName}`);
                    }, 2000);
                })
                .catch(() => {});
        },
        generateNo() {
            let that = this;
            that.$refs.codeRuleForm.validate(valid => {
                if (!valid) {
                    return false;
                }
                that.loading = true;
                that.$util
                    .axiosGet({
                        url: '/api/EntpShelfSpaces/GenerateNo',
                        data: {
                            WarehouseId: that.submitData.WarehouseId,
                            SNo: that.codeRuleData.SNo,
                            SCount: that.codeRuleData.SCount,
                            FloorCount: that.codeRuleData.FloorCount,
                            FSpaceCount: that.codeRuleData.FSpaceCount,
                            Suffix: that.codeRuleData.Suffix,
                            SpaceType:that.codeRuleData.SpaceType,
                            ZoneId : that.codeRuleData.ZoneId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) that.dataList = res.data;

                        that.dialogVisible = false;
                    })
                    .finally(() => {
                        that.loading = false;
                    });
            });
        },
        getZoneList() {
            let that = this;
            that.loading = true;
            if(that.zoneList.length == 0){
                that.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetZoneDataList',
                    data: {
                        WarehouseId: that.submitData.WarehouseId
                    }
                })
                .then(res => {
                    that.loading = false;
                    that.zoneList = res.data;
                });
            }
        },
    }
};
</script>
<style lang="less" scoped>
.dialog-footer {
    text-align: right;
}
</style>
<style lang="less">
.space-edit {
    .el-row {
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 10px;
        }
    }
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 8px 0;
                }
                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
                .operate {
                    padding: 0 12px;
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
                line-height: 32px;
                span {
                    padding-left: 10px;
                }
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }
    }
    .infinite-list-special-class {
        .elx-table {
            .elx-table--body-wrapper {
                padding-bottom: 0 !important;
            }
        }
    }
    .bottom-div {
        margin-top: 24px;
        .ship-amount {
            text-align: right;
            margin-bottom: 16px;
            .discount-count {
                font-size: 15px;
                font-weight: bold;
                color: #f00;
            }
        }
        .part {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 16px;
        }
    }
}
</style>
